import type { AnyAction } from 'redux';
import { combineReducers } from 'redux';
import Immutable from 'immutable';

import {
    markAnnouncementViewed,
    setAnnouncementsUnreadCount,
    setLoadingAnnouncements,
    storeAnnouncements,
} from 'js/src/data/announcements/announcement-actions';
import type { Announcement } from 'js/src/data/announcements/announcement-types';
import type { ImmutableMap } from 'js/src/libs/consts';

function list(
    state: Immutable.List<ImmutableMap<Announcement>> = Immutable.List(),
    action: AnyAction,
): Immutable.List<ImmutableMap<Announcement>> {
    if (storeAnnouncements.match(action)) {
        return action.payload.announcements;
    }
    if (markAnnouncementViewed.match(action)) {
        const index = state.findIndex((a) => a.get('id') === action.payload.announcementId);
        if (index !== -1) {
            return state.setIn([index, 'is_viewed'], true);
        }
    }
    return state;
}

function isLoading(state = false, action: AnyAction): boolean {
    if (setLoadingAnnouncements.match(action)) {
        return action.payload.isLoading;
    }
    return state;
}

function unreadCount(state = 0, action: AnyAction): number {
    if (setAnnouncementsUnreadCount.match(action)) {
        return action.payload.count;
    }
    return state;
}

export const announcements = combineReducers({
    list,
    isLoading,
    unreadCount,
});

export type AnnouncementsState = ReturnType<typeof announcements>;
